// SEO Schema.org JSON-LD utilities
// Use VITE_SITE_URL environment variable for domain

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "FIRETRAUMAS",
  "image": "https://public.readdy.ai/ai/img_res/a7c6a7f2-4945-4249-b551-f74c8da4a469.png",
  "url": import.meta.env.VITE_SITE_URL || "https://firetraumas.com",
  "telephone": "+34690220944",
  "email": "info@firetraumas.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Carrer de Septimània, 49",
    "addressLocality": "Barcelona",
    "addressRegion": "Cataluña",
    "postalCode": "08006",
    "addressCountry": "ES"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "41.403706",
    "longitude": "2.154007"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Barcelona"
    },
    {
      "@type": "AdministrativeArea",
      "name": "Área Metropolitana de Barcelona"
    }
  ],
  "priceRange": "€€",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "09:00",
      "closes": "14:00"
    }
  ],
  "sameAs": [
    "https://wa.me/34690220944"
  ]
});

export const getServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Limpieza Post Incendio",
  "provider": {
    "@type": "LocalBusiness",
    "name": "FIRETRAUMAS",
    "url": import.meta.env.VITE_SITE_URL || "https://firetraumas.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Barcelona"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Servicios de Limpieza Post Incendio",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Limpieza de Hollín y Residuos de Humo",
          "description": "Eliminación profesional de hollín y residuos de humo con equipos HEPA"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Neutralización de Olores Persistentes",
          "description": "Tratamiento profesional de desodorización para eliminar olores a humo"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Retirada de Cenizas y Escombros",
          "description": "Gestión segura de cenizas, escombros y enseres dañados"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Limpieza Profunda de Cocinas Quemadas",
          "description": "Limpieza especializada de cocinas con productos específicos"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Desinfección y Saneamiento",
          "description": "Desinfección completa y control de humedad post incendio"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Preparación para Pintura y Reformas",
          "description": "Preparación del espacio para trabajos de reforma"
        }
      }
    ]
  }
});

export const getFAQSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "¿Cuánto cuesta una limpieza post incendio en Barcelona?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "El coste varía significativamente según múltiples factores: superficie afectada en m², gravedad del incendio (leve, moderado o grave), número de habitaciones, volumen de enseres a retirar, tipo de materiales afectados, acceso al inmueble y disponibilidad de ascensor, y nivel de urgencia. Como referencia orientativa, un piso de 70-90 m² con daños moderados puede oscilar entre 2.000€ y 5.000€, pero cada caso es único. Ofrecemos presupuestos personalizados sin compromiso tras una inspección inicial."
      }
    },
    {
      "@type": "Question",
      "name": "¿Cuánto tarda una limpieza completa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "El tiempo depende de la gravedad y extensión. Un piso de 60 m² con incendio leve en cocina puede tardar 2-3 días laborables; un piso de 90 m² con daños moderados en varias estancias, entre 4-6 días; un piso de 120 m² con daños graves y necesidad de vaciado completo, entre 7-10 días o más. Estos plazos pueden alargarse si hay que esperar aprobaciones del seguro o perito."
      }
    },
    {
      "@type": "Question",
      "name": "¿Cubre el seguro este servicio de limpieza?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "La mayoría de seguros de hogar con cobertura de incendios incluyen la limpieza post incendio dentro de los daños cubiertos. Sin embargo, cada póliza es diferente. Es fundamental que contactes con tu aseguradora inmediatamente tras el incendio, abras un parte, y esperes la visita del perito antes de iniciar trabajos importantes. Nosotros tenemos experiencia trabajando con las principales aseguradoras en Barcelona y facilitamos toda la documentación necesaria para tu reclamación."
      }
    },
    {
      "@type": "Question",
      "name": "¿Es seguro entrar en casa después de un incendio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Depende de la gravedad. Tras un incendio, el aire puede contener partículas tóxicas, monóxido de carbono residual, y el hollín contiene sustancias cancerígenas. Las estructuras pueden estar debilitadas. No recomendamos entrar sin evaluación profesional. Si necesitas recuperar objetos urgentes, hazlo con mascarilla FFP3, guantes y ventilación, y el mínimo tiempo posible."
      }
    },
    {
      "@type": "Question",
      "name": "¿Atendéis fuera de Barcelona ciudad?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sí, trabajamos en toda Barcelona ciudad y el Área Metropolitana de Barcelona (AMB), que incluye más de 30 municipios: Badalona, L'Hospitalet, Santa Coloma, Cornellà, Sant Boi, Esplugues, Sant Just, Sant Feliu, Molins de Rei, El Prat, Viladecans, Gavà, Castelldefels, Sant Adrià, Montgat, Sant Cugat, Cerdanyola, Ripollet, y muchos más."
      }
    }
  ]
});

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "FIRETRAUMAS",
  "url": import.meta.env.VITE_SITE_URL || "https://firetraumas.com",
  "logo": "https://public.readdy.ai/ai/img_res/a7c6a7f2-4945-4249-b551-f74c8da4a469.png",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+34690220944",
    "contactType": "customer service",
    "areaServed": "ES",
    "availableLanguage": ["Spanish", "Catalan"]
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Carrer de Septimània, 49",
    "addressLocality": "Barcelona",
    "addressRegion": "Cataluña",
    "postalCode": "08006",
    "addressCountry": "ES"
  }
});

export const getBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `${import.meta.env.VITE_SITE_URL || "https://firetraumas.com"}${item.url}`
  }))
});

export const getWebPageSchema = (pageName: string, description: string, url: string) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": pageName,
  "description": description,
  "url": `${import.meta.env.VITE_SITE_URL || "https://firetraumas.com"}${url}`,
  "inLanguage": "es-ES",
  "isPartOf": {
    "@type": "WebSite",
    "name": "FIRETRAUMAS",
    "url": import.meta.env.VITE_SITE_URL || "https://firetraumas.com"
  }
});

// Helper function to inject schema into page
export const injectSchema = (schema: object) => {
  if (typeof window === 'undefined') return;
  
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
  
  return () => {
    if (script.parentNode) {
      script.parentNode.removeChild(script);
    }
  };
};
